<template>
    <b-form>
        <template v-for="(filterField, index) in formData.filterfield_set">
              <b-form-group
              :label="filterField.field_verbose"
              :label-for=index.toString()
              >
                  <template v-if="
                  filterField.filter_type === 'in' ||
                  filterField.filter_type === 'exact' ||
                  filterField.filter_type === 'iexact'">
                      <template v-if=" 'choices' in filterField && filterField.choices !== null">
                          <v-select
                              :multiple="filterField.filter_type === 'in'"
                              :id="filterField.id.toString()"
                              :ref="filterField.id.toString()"
                              label="data"
                              :value="getValue(filterField.filter_value, filterField.filter_type === 'in')"
                              :options="Object.entries(filterField.choices).map(entry => { return { 'data':entry[1], 'id':entry[0]}})"
                              @input="(val) => { filterField.filter_value = setValue(val, filterField.filter_type === 'in'); $emit('form-data-changed', formData) }"
                              :reduce="(option) => option.id"
                          />
                      </template>
                      <template v-else-if=" filterField.path.length > 0">
                          <search-by-model-path-id-field
                                  :multiple="filterField.filter_type === 'in'"
                                  v-model="filterField.filter_value"
                                  @input="(val) => {filterField.filter_value = val; $emit('form-data-changed', formData ) }"
                                  :initial-value="
                                    filterField.filter_type === 'in' && typeof filterField.filter_value === 'string' ?
                                    filterField.filter_value.split(',').map(el => { return {[filterField.field] : filterField.filter_value }}) : [{[filterField.field] : filterField.filter_value }]"
                                  :reduce-key=filterField.field
                                  :label="filterField.field"

                                  :model-path="filterField.path"
                                  :root-model-id="initialObject.root_model"
                                  :field="filterField.field"
                          ></search-by-model-path-id-field>
                      </template>
                      <template v-else-if=" filterField.field_type === 'DateTimeField' || filterField.field_type === 'DateField'">
                          <flat-pickr
                            class="form-control"
                            v-model="filterField.filter_value"
                            :config="{ enableTime: filterField.field_type === 'DateTimeField', dateFormat: filterField.field_type === 'DateTimeField' ? 'Y-m-d H:i' : 'Y-m-d'}"
                            @on-change="() => { $emit('form-data-changed', formData ) }"
                          ></flat-pickr>
                      </template>
                      <template v-else>
                          <b-form-input
                            :id=index.toString()
                            v-model="filterField.filter_value"
                            @update="() => {$emit('form-data-changed', formData ) }"
                          />
                      </template>
                  </template>
                  <template v-else-if="
                  filterField.filter_type === 'gt' ||
                  filterField.filter_type === 'gte' ||
                  filterField.filter_type === 'lt' ||
                  filterField.filter_type === 'lte' ">
                      <template v-if=" filterField.field_type === 'DateTimeField' || filterField.field_type === 'DateField'">
                          <flat-pickr
                            class="form-control"
                            v-model="filterField.filter_value"
                            :config="{ enableTime: filterField.field_type === 'DateTimeField', dateFormat: filterField.field_type === 'DateTimeField' ? 'Y-m-d H:i' : 'Y-m-d'}"
                            @on-change="() => { $emit('form-data-changed', formData ) }"
                          ></flat-pickr>
                      </template>
                      <template v-else>
                          <b-form-input
                            :id=index.toString()
                            v-model="filterField.filter_value"
                            @update="() => {$emit('form-data-changed', formData ) }"
                          />
                      </template>
                  </template>
                  <template v-else-if="
                  filterField.filter_type === 'isnull' ||
                  filterField.filter_type === 'max' ||
                  filterField.filter_type === 'min'">
                      <v-select
                          :id="filterField.id.toString()"
                          :ref="filterField.id.toString()"
                          label="data"
                          v-model="filterField.filter_value"
                          :options="[{ data: 'Да', id: '0', }, { data: 'Нет', id: '1'}]"
                          @input="() => { $emit('form-data-changed', formData) }"
                          :reduce="(option) => option.id"
                      />
                  </template>
                  <template v-else>
                      <b-form-input
                        :id=index.toString()
                        v-model="filterField.filter_value"
                        @update="() => {$emit('form-data-changed', formData ) }"
                      />
                  </template>
            </b-form-group>
        </template>
    </b-form>
</template>

<script>
    import  store from "@/store"

    import { BButton, BFormInput, BFormGroup, BForm, BFormDatepicker } from 'bootstrap-vue'
    import { ref, onMounted } from '@vue/composition-api'
    import vSelect from 'vue-select'

    import flatPickr from 'vue-flatpickr-component'
    import SearchByModelPathIdField from "../../../../search/components/SearchByModelPathIdField";


    export default {
        components: {
            SearchByModelPathIdField,
            BForm,
            BFormInput,
            BFormGroup,
            BButton,
            BFormDatepicker,
            flatPickr,
            vSelect,
        },

        props: {
            initialObject: {
                type: Object,
                required: true,
            },
            reportObject: {
                type: Object,
                required: true,
            },
        },



        setup(props) {

            const formData = ref(JSON.parse(JSON.stringify({...props.reportObject})));

            // const fetchFilterOptions = (ctx, callback) => {
            //
            //     store.dispatch('search/search', {model_name: ctx.model_name})
            //         .then((response)=>{
            //             callback(response.data.results)
            //         })
            //         .catch((error)=>{
            //             console.log(error)
            //         })
            //
            // }
            //
            // const onSearch = (object, filterField, search, loading) => {
            //     console.log(object, filterField),
            //     fetchFilterOptions({model_name: filterField.path_verbose}, (data)=>{
            //         filterField.options = data
            //         object.options = filterField.options
            //     })
            // }

            const getValue = (initialValue, multiple) => {

                if (multiple === true && typeof initialValue === "string") {
                    return initialValue.split(',').map((option) =>{
                        return option
                    })
                } else {
                    return initialValue
                }
            }
            const setValue = (initialValue, multiple) => {
                if (multiple === true && Array.isArray(initialValue)) {
                    if (initialValue.length > 0) {
                         return initialValue.join(',')
                    }
                    return null
                } else {
                    return initialValue.toString()
                }

            }

            return {
                formData,
                // fetchFilterOptions,
                // onSearch,
                getValue,
                setValue
            }
        },
    }

</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
